




















































import Vue from 'vue';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import { MStoreOrderableTableDirection } from '@/types';
import { ObjectUtils } from '@/utils/objectUtils';

export default Vue.extend({
  name: 'MStoreOrderableTable',
  props: {
    isBusy: {
      type: Boolean,
      required: true
    },
    tableId: {
      type: String
    },
    items: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    emptyText: {
      type: String
    },
    emptyHtml: {
      type: String,
      default: ''
    },
    orderColumnKey: {
      type: String,
      required: true
    },
    pkField: {
      type: String
    },
    isDisabled: {
      type: Boolean
    },
    selectedItemKeys: {
      default: () => [],
      type: Array
    },
    selectable: {
      default: false,
      type: Boolean
    },
    selectedRowClass: {
      type: String,
      default: 'table-primary'
    },
    selectedRowClassOverridesRowClass: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedRow: null,
      selectedRowIndex: 0,
      newRow: null,
      newRowIndex: 0,
      hasError: false,
      errorMessage: ''
    };
  },
  computed: {
    orderedItems(this: any) {
      return this.items.sort((a: any, b: any) => a[this.orderColumnKey] - b[this.orderColumnKey]);
    },
    canMoveUp(this: any) {
      return this.selectedRow !== null && this.selectedRowIndex !== 0;
    },
    canMoveDown(this: any) {
      return this.selectedRow !== null && this.selectedRowIndex !== this.items.length - 1;
    }
  },
  methods: {
    validateOrderColumnKey(this: any) {
      const results = [];
      if (this.items[0] && this.items[0][this.orderColumnKey]) {
        for (let i = 0; i < this.items.length - 1; i++) {
          if (this.items[i + 1][this.orderColumnKey] === this.items[i][this.orderColumnKey] && results.indexOf(this.items[i][this.orderColumnKey]) === -1) {
            results.push(this.items[i][this.orderColumnKey]);
          }
          if (results.length > 0) {
            this.hasError = true;
            this.errorMessage = `The OrderColumnKey field contains duplicate value(s) - ${results}`;
          }
        }
      }
      if (this.items[0] && !this.items[0][this.orderColumnKey]) {
        this.hasError = true;
        this.errorMessage = `The items does not contain the OrderColumnKey - ${this.orderColumnKey}`;
      }
    },
    onRowClicked(this: any, item: any) {
      if (this.isDisabled) {
        return;
      }
      if (this.selectedRow === item) {
        this.selectedRow = null;
        return;
      }
      this.selectedRow = item;
      this.selectedRowIndex = this.orderedItems.indexOf(this.selectedRow);
      (this.newRow = null), (this.newRowIndex = 0);
    },
    emitChangeOrderEvent(this: any, direction: string, toIndex: number) {
      this.newRowIndex = toIndex;
      this.newRow = this.orderedItems[toIndex];
      const changeOrderEvent = {
        direction,
        fromItemIndex: this.items.findIndex((item: any) => item[this.orderColumnKey] === this.selectedRow[this.orderColumnKey]),
        toItemIndex: this.items.findIndex((item: any) => item[this.orderColumnKey] === this.newRow[this.orderColumnKey]),
        reorderedItems: []
      };
      const reorderedData = ObjectUtils.deepCloneObject(this.items);
      reorderedData[changeOrderEvent.fromItemIndex][this.orderColumnKey] = this.newRow[this.orderColumnKey];
      reorderedData[changeOrderEvent.toItemIndex][this.orderColumnKey] = this.selectedRow[this.orderColumnKey];
      changeOrderEvent.reorderedItems = reorderedData;
      this.selectedRowIndex = this.newRowIndex;
      this.selectedRow = this.newRow;
      this.$emit('on-change-order', changeOrderEvent);
    },
    onMoveUp(this: any) {
      this.emitChangeOrderEvent(MStoreOrderableTableDirection.Up, this.selectedRowIndex - 1);
    },
    onMoveDown(this: any) {
      this.emitChangeOrderEvent(MStoreOrderableTableDirection.Down, this.selectedRowIndex + 1);
    },
    rowClass(this: any, item: any) {
      if (item !== null && this.orderColumnKey in item) {
        if (this.selectedRow === item || (this.newRow !== null && this.newRow[this.orderColumnKey] === item[this.orderColumnKey])) {
          return 'table-success';
        }
      }
    }
  },
  mounted(this: any) {
    this.validateOrderColumnKey();
  },
  components: {
    MStoreTable
  }
});
